import {
  Component,
  OnInit,
  OnDestroy,
  Signal,
  WritableSignal,
  signal,
  inject,
  Pipe,
  PipeTransform,
  ElementRef,
  ViewChild
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule, Router } from '@angular/router';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Subject, takeUntil } from 'rxjs';
import { ExportToExcelComponent } from './excel';
import * as timeago from 'timeago.js';
import es from 'timeago.js/lib/lang/es';
import { Navbar } from './navbar';
import { environment } from '../../environments/environment';

timeago.register('es', es);

// Pipe personalizado para replicar TimeAgo
@Pipe({
  name: 'timeAgo',
  standalone: true
})
export class TimeAgoPipe implements PipeTransform {
  transform(value: string | Date | null | undefined): string {
    if (!value) return '';
    const date = typeof value === 'string' ? new Date(value) : value;
    return timeago.format(date, 'es');
  }
}

// Interfaces de Tipo de Datos
export interface User {
  _id: string;
  name: string;
  email: string;
  rol: string;
  mencion?: string;
  ciclo?: string;
  tipostd?: string;
  dni?: string;
  dateb?: string;
  datee?: string;
}

export interface Curse {
  _id: string;
  title: string;
  description?: string;
  mencion?: string;
  credito?: string;
  ciclo?: string;
  codigo?: string;
  img?: string;
}

export interface CurseGroup {
  _id: string;
  records: Curse[];
}

export interface GeneratedCurse {
  curses: Curse[];
}

export interface ConvalidateRecord {
  _id: string;
  username: string;
  useremail: string;
  title: string;
  mencion: string;
  ciclo: string;
}

@Component({
  selector: 'app-create-note',
  standalone: true,
  imports: [ExportToExcelComponent, Navbar, CommonModule, FormsModule, RouterModule, TimeAgoPipe],
  template: `
    <!-- Contenedor Toast / Notificaciones -->
    <div class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 10850;">
      @for (toast of toasts(); track $index) {
        <div class="toast show align-items-center text-white border-0 mb-2" [ngClass]="toast.bgClass" role="alert">
          <div class="d-flex">
            <div class="toast-body">{{ toast.message }}</div>
            <button type="button" class="btn-close btn-close-white me-2 m-auto" (click)="removeToast($index)"></button>
          </div>
        </div>
      }
    </div>

<app-navbar></app-navbar>  
<div class="py-3"></div>

    <!-- Modal Bootstrap -->
    @if (showModal()) {
      <div class="modal fade show d-block" tabindex="-1" style="background-color: rgba(0,0,0,0.5);">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header font-weight-bold">
              <h5 class="modal-title">{{ submit() }}</h5>
              <button type="button" class="btn-close" (click)="closeModal()"></button>
            </div>
            <div class="modal-body">
              @if (!convalidate()) {
                @if (option() === '1' || option() === '3') {
                  <div class="justify-content-center align-items-center" style="padding: .1em;">
                    @for (message of cursesSource(); track message._id) {
                      <div style="padding: .1em;">
                        <div class="text-center border-warning border-bottom border-3" style="margin: .1em 0; color: orange; width: 100%;">
                          {{ message._id }}
                        </div>
                        <div class="row justify-content-center align-items-center" style="padding: .1em;">
                          @for (messagge of message.records; track messagge._id) {
                            <div class="col-sm-12 col-md-6 col-lg-6 col-xl-4" style="padding: .1em;">
                              <button
                                class="btn btn-info w-100"
                                (click)="handleSelectSourceCurse(messagge)"
                              >
                                {{ messagge.title }} <span style="color: black;">[{{ messagge.mencion }} {{ messagge.ciclo }}]</span>
                              </button>
                            </div>
                          }
                        </div>
                      </div>
                    }
                  </div>
                } @else {
                  <div class="card form-group mb-2">
                    <div class="componentWrappertextleft p-2 font-weight-bold">Nombre</div>
                    <input type="text" class="form-control" placeholder="Nombre" [(ngModel)]="title" required />
                  </div>
                  <div class="card form-group mb-2">
                    <div class="componentWrappertextleft p-2 font-weight-bold">Contenido</div>
                    <textarea class="form-control border-0 rounded-0" placeholder="Contenido" rows="2" [(ngModel)]="description" required></textarea>
                  </div>
                  <input type="file" #fileInputRef class="form-control d-none" (change)="onFileSelected($event)" />
                  <img
                    className="img-fluid style-preview cursor-pointer"
                    [src]="photoSelected() || (apiUrl + '/collections/' + foto())"
                    alt="Vista previa"
                    (click)="triggerFileInput()"
                    (error)="handleImageError($event)"
                    style="max-height: 250px; object-fit: cover; cursor: pointer;"
                  />
                }
              } @else {
                <div>
                  <p>{{ option() }} | Crédito: {{ credito() }} | Ciclo: {{ ciclo() }} | Mención: {{ mencion() }} | Código: {{ codigo() }} | ID: {{ curseid() }} | {{ title() }}</p>
                  <input type="text" class="form-control" placeholder="Nota" [(ngModel)]="nota" required />
                </div>
              }
            </div>
            <div class="modal-footer">
              @if (option() === '2') {
                <button class="btn btn-info" (click)="curseUpdate()">Actualizar curso</button>
              }
              @if (option() === '3') {
                <button class="btn btn-warning" (click)="userConvalidate()">Convalidar</button>
              }
              <button type="button" class="btn btn-secondary" (click)="closeModal()">Cerrar</button>
            </div>
          </div>
        </div>
      </div>
    }

    <!-- Contenido Principal -->
    <div class="container">
      <div class="p-1 my-1 text-center ffont h3">
        <span>{{ activeUser()?.name }}</span><br />
        <span class="h5">{{ activeUser()?.email }}</span>
      </div>

      <!-- Cuadrícula de Cursos Generados -->
      <div class="row justify-content-center align-items-center" style="padding: .3em; margin-bottom: 1em;">
        @for (message of generatedCurses(); track $index) {
          <div class="col-sm-12 col-md-6 col-lg-6 col-xl-4">
            <div class="p-1 rounded contenedor position-relative">
              <img
                class="image rounded img-fluid"
                [src]="apiUrl + '/collections/' + message.curses[0]?.img"
                alt="Curso"
                (error)="handleImageError($event)"
              />
              <div class="overlay-text p-2">
                <div class="border rounded text-center ffont h5 text-white" style="background-color: rgba(54, 119, 166, 0.5);">
                  {{ message.curses[0]?.title }} {{ message.curses[0]?.credito }}
                </div>
                <div class="btn-group w-100">
                  <button
                    class="btn btn-warning w-100"
                    style="background-color: rgba(0, 0, 0, 0.3);"
                    (click)="navigateToCourse(message.curses[0])"
                  >
                    Abrir Curso
                  </button>
                </div>
              </div>
            </div>
          </div>
        }
      </div>

      <!-- Panel de Administración (Rol == '1') -->
      @if (activeUser() && activeUser()?.rol === '1') {
        <div class="text-center">
          <div class="text-center rounded p-1 bg-light">
            <div class="text-center text-warning ffont h3">Roles</div>
            <div class="btn-group flex-wrap">
              @for (role of ['1', '2', '3', '4', '5', 'subscriber']; track role) {
                <button type="button" class="btn btn-warning m-1" (click)="getStd(role)">
                  {{ role === 'subscriber' ? 'Subscriptor' : role }}
                </button>
              }
            </div>
          </div>

          <div class="text-center rounded p-1 mt-1 bg-light">
            <a class="btn btn-warning text-uppercase text-light m-1" routerLink="/adduser">
              Integrar usuario nuevo
            </a>
            <button type="button" class="btn btn-primary text-uppercase m-1" (click)="getConvalidates()">
              Convalidados
            </button>

            <div class="row justify-content-center align-items-center">
              @for (message of stdsConvalidate(); track message._id) {
                <div class="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                  <div class="p-1 rounded border mb-1">
                    {{ message.username }} {{ message.useremail }} {{ message.title }} [{{ message.mencion }}] [{{ message.ciclo }}]
                    <button type="button" class="btn btn-danger btn-sm w-100 mt-1" (click)="deleteConvalidate(message._id)">
                      Eliminar
                    </button>
                  </div>
                </div>
              }
            </div>

            <!-- Ajustes de Fecha -->
            <div class="row p-1 d-flex justify-content-center align-items-center">
              <div class="col-md-6 p-1 text-center">
                Inicia {{ activeUser()?.dateb | timeAgo }}<br />
                <input
                  type="datetime-local"
                  class="btn btn-info w-100"
                  [ngModel]="formatDateForInput(activeUser()?.dateb)"
                  (ngModelChange)="updateLimitGetAverage($event, 'dateb')"
                />
              </div>
              <div class="col-md-6 p-1 text-center">
                Culmina {{ activeUser()?.datee | timeAgo }}<br />
                <input
                  type="datetime-local"
                  class="btn btn-info w-100"
                  [ngModel]="formatDateForInput(activeUser()?.datee)"
                  (ngModelChange)="updateLimitGetAverage($event, 'datee')"
                />
              </div>
            </div>

            <!-- Filtros Avanzados -->
            <div class="d-flex justify-content-center align-items-center gap-2 mt-2 flex-wrap">
              <select class="form-select w-auto" [(ngModel)]="year">
                @for (opt of yearOptions; track opt.value) {
                  <option [value]="opt.value">{{ opt.label }}</option>
                }
              </select>

              <select class="form-select w-auto" [(ngModel)]="mencion">
                @for (opt of mencionOptions; track opt.value) {
                  <option [value]="opt.value">{{ opt.label }}</option>
                }
              </select>

              <select class="form-select w-auto" [(ngModel)]="ciclo">
                @for (opt of cicloOptions; track opt.value) {
                  <option [value]="opt.value">{{ opt.label }}</option>
                }
              </select>
            </div>
          </div>
<app-export-to-excel 
  [year]="year()" 
  [ciclo]="ciclo()" 
  [mencion]="mencion()">
</app-export-to-excel>

      
          <!-- Módulo de Administración de Estudiantes -->
          @if (hasStudentsActive()) {
<div class="mt-3 p-3 border rounded bg-white">
  <h4>Administrador de Estudiantes</h4>
  <div class="list-group">
    @for (std of stds(); track std._id) {
      <div class="list-group-item d-flex justify-content-between align-items-center flex-wrap gap-2">
        <span>{{ std.mencion }} ({{ std.notas }}) {{ std.records?.length || 0 }}</span>

        @if ((std.records?.length || 0) > 0) {
          <div class="d-flex flex-wrap gap-1">
            @for (sttd of std.records; track sttd._id) {
              <span class="badge bg-secondary">{{ sttd.email }}</span>
            }
          </div>
        }

        <button
          class="btn btn-sm btn-outline-primary"
          (click)="onConvalidateClick(std, 'Arte', 'Arte')"
        >
          Convalidar Curso
        </button>
      </div>
    }
  </div>
</div>
          }
        </div>
      }

      <!-- Módulo del Profesor (Rol == '2') -->
      @if (activeUser() && activeUser()?.rol === '2') {
        <div class="container p-0 text-center my-3">
          <div class="d-flex justify-content-center align-items-center gap-2">
            <select class="form-select w-auto" [(ngModel)]="mencion">
              @for (opt of mencionOptions; track opt.value) {
                <option [value]="opt.value">{{ opt.label }}</option>
              }
            </select>

            <select class="form-select w-auto" [(ngModel)]="semestre">
              @for (opt of semestreOptions; track opt.value) {
                <option [value]="opt.value">{{ opt.label }}</option>
              }
            </select>
          </div>

          <div style="margin-top: .5em;">
            <button
              type="button"
              className="btn btn-primary text-uppercase"
              (click)="openAddTeacherCoursesModal()"
            >
              Agregar cursos ESFA FGPA
            </button>
          </div>

          <div class="row justify-content-center align-items-center mt-3">
            @for (message of cursesTeacher(); track message._id; let idx = $index) {
              <div class="col-sm-12 col-md-6 col-lg-6 col-xl-4 mb-3">
                <div class="p-1 rounded contenedor border">
                  <img
                    class="image img-fluid"
                    [src]="apiUrl + '/collections/' + message.img"
                    alt="Curso"
                    (error)="handleImageError($event)"
                  />
                  <div class="overlay-text p-2">
                    <div class="mb-3 h4 border rounded ffont text-light">
                      {{ message.title }} [{{ message.mencion }}] [{{ message.ciclo }}]
                    </div>
                    <div>
                      <button
                        class="btn btn-warning text-light w-100 mt-2"
                        style="background-color: rgba(0, 0, 0, 0.5);"
                        (click)="navigateToCourse(message)"
                      >
                        Ir al curso
                      </button>
                      <button
                        type="button"
                        class="btn btn-danger mt-2 w-100"
                        (click)="deleteCurse(message._id)"
                      >
                        Eliminar Curso
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      }

      <!-- Módulo del Estudiante (Rol == '3') -->
      @if (activeUser() && activeUser()?.rol === '3') {
        <div class="my-3 p-3 border rounded bg-light">
          <h3>Panel de Notas del Estudiante</h3>
          <div class="table-responsive">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>Curso</th>
                  <th>Nota</th>
                </tr>
              </thead>
              <tbody>
                @for (item of stdCalification(); track $index) {
                  <tr>
                    <td>{{ item.title || item.curso }}</td>
                    <td>{{ item.nota }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      }
    </div>
    <div class="py-3"></div>
  `
})
export class CreateNoteComponent implements OnInit, OnDestroy {
  private http = inject(HttpClient);
  private router = inject(Router);
  private destroy$ = new Subject<void>();

  readonly apiUrl = `${environment.apiURL}/api`; // Ajusta REACT_APP_API_URL según tus variables de entorno
  readonly defaultImg = 'assets/www.jpg';

  @ViewChild('fileInputRef') fileInputRef!: ElementRef<HTMLInputElement>;

  // Opciones de Selects
  yearOptions = [
    { value: '2022', label: '2022' },
    { value: '2023', label: '2023' },
    { value: '2024', label: '2024' },
    { value: '2025', label: '2025' },
    { value: '2026', label: '2026' }
  ];

  mencionOptions = [
    { value: 'ED', label: 'ED' },
    { value: 'E', label: 'E' },
    { value: 'G', label: 'G' },
    { value: 'P', label: 'P' }
  ];

  cicloOptions = Array.from({ length: 10 }, (_, i) => ({
    value: String(i + 1),
    label: String(i + 1)
  }));

  semestreOptions = [
    { value: 'i', label: 'IMPAR' },
    { value: 'p', label: 'PAR' }
  ];

  // Señales de Estado (Signals)
  activeUser: WritableSignal<User | null> = signal(null);
  cursesTeacher: WritableSignal<Curse[]> = signal([]);
  report: WritableSignal<any[]> = signal([]);
  cursesSource: WritableSignal<CurseGroup[]> = signal([]);
  stdCalification: WritableSignal<any[]> = signal([]);
  stds: WritableSignal<any[]> = signal([]);
  stdsConvalidate: WritableSignal<ConvalidateRecord[]> = signal([]);
  student: WritableSignal<User | null> = signal(null);
  generatedCurses: WritableSignal<GeneratedCurse[]> = signal([]);

  // Form & UI Signals
  files: WritableSignal<File | null> = signal(null);
  photoSelected: WritableSignal<string> = signal('');
  namefile: WritableSignal<string> = signal('');

  title: WritableSignal<string> = signal('');
  description: WritableSignal<string> = signal('');
  nota: WritableSignal<string> = signal('');
  mencion: WritableSignal<string> = signal('ED');
  ciclo: WritableSignal<string> = signal('1');
  year: WritableSignal<string> = signal('2025');
  semestre: WritableSignal<string> = signal(new Date().getMonth() + 1 < 8 ? 'i' : 'p');

  curseid: WritableSignal<string> = signal('');
  idcurse: WritableSignal<string> = signal('');
  foto: WritableSignal<string> = signal('');
  codigo: WritableSignal<string> = signal('');
  credito: WritableSignal<string> = signal('');

  showModal: WritableSignal<boolean> = signal(false);
  convalidate: WritableSignal<boolean> = signal(false);
  submit: WritableSignal<string> = signal('');
  option: WritableSignal<string> = signal('2');

  // Sistema Interno de Toasts
  toasts: WritableSignal<{ message: string; bgClass: string }[]> = signal([]);

  ngOnInit(): void {
    const userStr = localStorage.getItem('user');
    if (userStr) {
      try {
        const user: User = JSON.parse(userStr);
        this.activeUser.set(user);
      } catch (e) {
        console.error('Error parseando usuario de localStorage', e);
      }
    }

    const currentAuth = this.activeUser();
    if (currentAuth) {
      this.getGenerateCurses();
      this.getNotes();
      if (currentAuth.rol === '3') {
        this.getStdCalifications();
      }
    }

    // Limpieza de Cookies / LocalStorage según lógica original
    ['idc', 'idcat', 'curse'].forEach(field => {
      localStorage.removeItem(field);
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  // Notificaciones Toast
  showToast(message: string, type: 'info' | 'error' | 'warning' | 'dark' = 'info') {
    const bgClasses = {
      info: 'bg-info',
      error: 'bg-danger',
      warning: 'bg-warning text-dark',
      dark: 'bg-dark'
    };
    const newToast = { message, bgClass: bgClasses[type] || 'bg-info' };
    this.toasts.update(current => [...current, newToast]);

    setTimeout(() => {
      this.toasts.update(current => current.filter(t => t !== newToast));
    }, 3000);
  }

  removeToast(index: number) {
    this.toasts.update(current => current.filter((_, i) => i !== index));
  }

  // Métodos HTTP / Operaciones principales
  getNotes() {
    const user = this.activeUser();
    if (!user?._id) return;

    this.http.get<any[]>(`${this.apiUrl}/curses/cursosespecificos/${user._id}/true/source`)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data) => {
          if (data?.[0]) {
            this.cursesTeacher.set(data[0].curses || []);
            this.report.set(data[0].cursesstd || []);
          }
        },
        error: () => this.showToast('Error cargando notas.', 'error')
      });
  }

  getGenerateCurses() {
    const user = this.activeUser();
    if (!user?._id) return;

    this.http.get<GeneratedCurse[]>(`${this.apiUrl}/curses/Getgeneratecursosculqui/${user._id}/true`)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => this.generatedCurses.set(Array.isArray(res) ? res : []),
        error: (err: HttpErrorResponse) => this.showToast(`Error al generar cursos: ${err.message}`, 'error')
      });
  }

  getStdCalifications() {
    const user = this.activeUser();
    if (!user?._id) return;

    this.http.get<any[]>(`${this.apiUrl}/users/stdnotes/${user._id}`)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data) => this.stdCalification.set(Array.isArray(data) ? data : []),
        error: () => this.showToast('Error al cargar calificaciones del estudiante.', 'error')
      });
  }

  getSourcesCurses(targetMencion: string, targetCiclo: string) {
    this.http.get<CurseGroup[]>(`${this.apiUrl}/curses/cursossources/${targetMencion}/${targetCiclo}`)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data) => {
          this.cursesSource.set(data || []);
          this.openModal();
        },
        error: (err: HttpErrorResponse) => this.showToast(`Error al obtener información: ${err.message}`, 'error')
      });
  }

  updateLimitGetAverage(dateValue: string, name: string) {
    this.http.post(`${this.apiUrl}/users/UpdateLimitGetAverage`, { date: dateValue, name }, { responseType: 'text' })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => this.showToast(res, 'info'),
        error: () => this.showToast('Error al guardar la fecha', 'error')
      });
  }

  getStd(rol: string) {
    this.http.get<User[]>(`${this.apiUrl}/users/userAll/${rol}`)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data) => {
          let list = Array.isArray(data) ? [...data] : [];
          if (rol === '3' && list.length > 1) {
            const nIndex = list.findIndex(item => item?._id === 'N');
            if (nIndex !== -1) {
              const temp = list[nIndex];
              list[nIndex] = list[list.length - 1];
              list[list.length - 1] = temp;
            }
          }
          console.log(list)
          this.stds.set(list);
          this.stdsConvalidate.set([]);
        },
        error: () => this.showToast('Error al cargar estudiantes.', 'error')
      });
  }

  curseUpdate() {
    const formData = new FormData();
    const currentFile = this.files();
    if (currentFile) formData.append('img', currentFile);
    formData.append('description', this.description());
    formData.append('title', this.title());

    this.http.put(`${this.apiUrl}/curses/${this.idcurse()}`, formData, { responseType: 'text' })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          this.showToast(res, 'dark');
          this.closeModal();
          this.getNotes();
        },
        error: (err: HttpErrorResponse) => this.showToast(`Error de actualización: ${err.message}`, 'error')
      });
  }

  curseCreate(id: string, cTitle: string, cDesc: string, cMencion: string, cCredito: string, cCiclo: string, cCodigo: string) {
    const user = this.activeUser();
    if (!user?._id) return;

    const payload = {
      user: user._id,
      show: 'true',
      mencion: cMencion,
      credito: cCredito,
      ciclo: cCiclo,
      codigo: cCodigo,
      title: cTitle,
      type: 'source',
      year: String(new Date().getFullYear()),
      description: cDesc
    };

    this.http.post(`${this.apiUrl}/curses/`, payload, { responseType: 'text' })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          if (res === 'Ya agregó el curso') {
            this.showToast(res, 'error');
          } else {
            this.showToast(res, 'dark');
            this.closeModal();
            this.getNotes();
          }
        },
        error: (err: HttpErrorResponse) => this.showToast(`Error al crear curso: ${err.message}`, 'error')
      });
  }

  userUpdate(id: string, rol: string, uMencion: string, uCiclo: string, tipostd: string, dni: string, name: string) {
    this.http.put(`${this.apiUrl}/users/user/${id}`, { rol, mencion: uMencion, ciclo: uCiclo, tipostd, dni, name }, { responseType: 'text' })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => this.showToast(res, 'dark'),
        error: (err: HttpErrorResponse) => this.showToast(`Error al actualizar usuario: ${err.message}`, 'error')
      });
  }

  userConvalidate() {
    if (!this.nota()) {
      this.showToast('Rellene el campo', 'warning');
      return;
    }
    const std = this.student();
    const teacher = this.activeUser();

    const payload = {
      user: std?._id,
      useremail: std?.email,
      username: std?.name,
      teacher: teacher?._id,
      teacheremail: teacher?.email,
      teacherrol: teacher?.rol,
      curso: this.curseid(),
      title: this.title(),
      ciclo: this.ciclo(),
      codigo: this.codigo(),
      credito: this.credito(),
      mencion: this.mencion(),
      nota: this.nota(),
      year: new Date().getFullYear()
    };

    this.http.post(`${this.apiUrl}/curses/average`, payload, { responseType: 'text' })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          this.showToast(res, 'dark');
          this.closeModal();
          this.getConvalidates();
          this.convalidate.set(false);
        },
        error: (err: HttpErrorResponse) => {
          this.convalidate.set(false);
          this.showToast(`Error al convalidar: ${err.message}`, 'error');
        }
      });
  }

  getConvalidates() {
    const user = this.activeUser();
    this.http.get<ConvalidateRecord[]>(`${this.apiUrl}/curses/averagestd/${user?.rol}/${new Date().getFullYear()}`)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          this.stdsConvalidate.set(Array.isArray(res) ? res : []);
          this.stds.set([]);
        },
        error: () => this.showToast('Error al cargar convalidados', 'error')
      });
  }

  deleteConvalidate(noteId: string) {
    if (confirm('¿Deseas eliminar este convalidado?')) {
      this.http.delete(`${this.apiUrl}/curses/average/${noteId}`)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: () => {
            this.getConvalidates();
            this.showToast('Removido correctamente', 'dark');
          },
          error: () => this.showToast('Error al eliminar el curso.', 'error')
        });
    }
  }

  deleteCurse(noteId: string) {
    if (confirm('¿Deseas eliminar este curso?')) {
      this.http.delete(`${this.apiUrl}/curses/${noteId}`)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: () => {
            this.getNotes();
            this.showToast('Removido correctamente', 'dark');
          },
          error: () => this.showToast('Error al eliminar el curso.', 'error')
        });
    }
  }

  // Manipulación de Archivos
  onFileSelected(event: Event) {
    const target = event.target as HTMLInputElement;
    if (target.files && target.files[0]) {
      const selectedFile = target.files[0];
      this.files.set(selectedFile);

      const reader = new FileReader();
      reader.onload = () => {
        this.photoSelected.set(reader.result as string);
        this.namefile.set(selectedFile.type);
      };
      reader.readAsDataURL(selectedFile);
    }
  }

  triggerFileInput() {
    this.fileInputRef?.nativeElement?.click();
  }

  // Helpers y UI Action
  handleSelectSourceCurse(messagge: Curse) {
    if (this.option() === '3') {
      this.convalidate.set(true);
      this.curseid.set(messagge._id);
      this.title.set(messagge.title);
      this.mencion.set(messagge.mencion || 'ED');
      this.credito.set(messagge.credito || '');
      this.ciclo.set(messagge.ciclo || '1');
      this.codigo.set(messagge.codigo || '');
      this.submit.set('Calificar curso a convalidar');
    } else {
      this.curseCreate(messagge._id, messagge.title, 'message.description', messagge.mencion || '', messagge.credito || '', messagge.ciclo || '', messagge.codigo || '');
    }
  }

  openAddTeacherCoursesModal() {
    const mentionNames: Record<string, string> = { P: 'Pintura', G: 'Grabado', ED: 'Educación artística', E: 'Escultura' };
    this.submit.set(`Agregar cursos [Mención: ${mentionNames[this.mencion()] || this.mencion()}. Semestre: ${this.semestre() === 'i' ? 'Impar' : 'Par'}]`);
    this.option.set('1');
    this.getSourcesCurses(this.mencion(), this.semestre());
  }

  onConvalidateClick(std: User, messageId: string, label: string) {
    this.submit.set(`Selecionar curso a convalidar, de los cursos de ${label || 'Arte'} [Impar]`);
    this.option.set('3');
    this.student.set(std);
    this.getSourcesCurses(messageId, this.semestre());
  }

  navigateToCourse(curseItem: Curse) {
    localStorage.setItem('curse', JSON.stringify(curseItem));
    this.router.navigate(['/curso', curseItem._id]);
  }

  openModal() { this.showModal.set(true); }
  closeModal() { this.showModal.set(false); }

  hasStudentsActive(): boolean {
    return this.stds().length > 0;
  }

  handleImageError(event: Event) {
    (event.target as HTMLImageElement).src = this.defaultImg;
  }

  formatDateForInput(dateStr?: string): string {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    return d.toISOString().slice(0, 16);
  }
}